import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BaseBinderWizardService } from 'src/app/services/interfaces/base-binder-wizard-service';
import { BinderWizardService } from 'src/app/services/sections/binder/binder-wizard.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';

@Component({
  selector: 'binder-viewer',
  templateUrl: './binder-viewer.component.html',
  styleUrls: ['./binder-viewer.component.scss'],
  providers: [
    { provide: BaseBinderWizardService, useClass: BinderWizardService }
  ]
})
export class BinderViewerComponent implements OnInit, AfterViewInit{

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }
}
